import styled from "styled-components";

export const EquipmentRoot = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;

  @media (max-width: ${({ theme }) => theme.mobile}) {
    flex-direction: column;
  }
`

export const EquipmentContainer = styled.div`
  width: 50%;
`
export const EquipmentContainerInner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const EquipmentContainerMobile = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
`

export const Header = styled.div`
  width: 100%;
  display: grid;
  flex-direction: row;
  align-items: center;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(1, 1fr);

  @media (max-width: ${({ theme }) => theme.mobile}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`

export const Basejump = styled.img`
  display: flex;
  width: 100%;
  height: 100%;
  // background-size: cover;
  // background-position: left;
  // background-repeat: no-repeat;
  grid-column: 1;
  grid-row: 1;
  width: 100%;
  object-fit: contain;
  @media (max-width: ${({ theme }) => theme.mobile}) {
    width: 50%;
  }
`

export const IncubationSystem = styled.div `
  display: flex;
  font-family: "NeueMachina";
  line-height: 1;
  letter-spacing: -1px;
  margin: 0;
  grid-column: 2 / 4;
  grid-row: 1;
  justify-content: flex-end;

  @media (max-width: 3300px) {
    font-size: 2.4rem;
  }

  @media (max-width: 1800px) {
      font-size: 2rem;
  }

  @media (max-width: 1540px) {
      font-size: 1.5rem;
  }

  @media (max-width: 1170px) {
      font-size: 1.2rem;
  }

  @media (max-width: 950px) {
    font-size: 0.8rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    width: 100%;
    justify-content: center;
  }
`

export const TitleContainer = styled.div`
  margin-top: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: start;
  gap: 10px;
  // grid-template-columns: repeat(4, 1fr);
  // grid-template-rows: repeat(1, 1fr);
  // column-gap: 10px;

  @media (max-width: 2400px) {
    margin-top: 20px;
  }

  @media (max-width: 1900px) {
    margin-top: 15px;
  }

  @media (max-width: 1366px) {
    margin-top: 10px;
  }

  @media (max-width: 900px) {
    margin-top: 5px;
  }
`

export const Spacer = styled.div `
  display: flex;
  height: 4px;
  width: 100%;
  background: white;
  // grid-column: 1;
  // grid-row: 1;
  // align-self: center;

  @media (max-width: 3300px) {
    margin-top: calc((3rem)/2);
  }

  @media (max-width: 2400px) {
    margin-top: calc((2.1rem)/2);
  }

  @media (max-width: 1740px) {
    margin-top: calc((1.8rem )/2);
  }

  @media (max-width: 1540px) {
    margin-top: calc((1.5rem )/2);
  }

  @media (max-width: 1280px) {
    margin-top: calc((1.2rem )/2);
  }

  @media (max-width: 1080px) {
    margin-top: calc((1rem )/2);
  }

  @media (max-width: 930px) {
    margin-top: calc((0.7rem )/2);
  }
  
  
`

export const TitleLine = styled.div`  
  font-size: 26px;
  font-family: "NeueMachina";
  font-weight: 100;
  letter-spacing: 1px;
  margin: 0;
  grid-column: 2/5;
  line-height: 1.4;

  b {
    color: #00CFFF;
  }

  a {
    text-decoration-color: #00CFFF;
  }

  @media (max-width: 3300px) {
    font-size: 3rem;
  }

  @media (max-width: 2400px) {
      font-size: 2.1rem;
  }

  @media (max-width: 1740px) {
      font-size: 1.8rem;
  }

  @media (max-width: 1540px) {
    font-size: 1.5rem;
}

  @media (max-width: 1280px) {
      font-size: 1.2rem;
  }

  @media (max-width: 1080px) {
    font-size: 1rem;
  }

  @media (max-width: 930px) {
    font-size: 0.7rem;
  }

  @media (max-width: ${({ theme }) => theme.mobile}) {
    width: 100%;
  }
`

export const Delimiter = styled.div `
  width: 100%;
  height: 2px;
  background: white;
`

export const Weapons = styled.img`
  width: 100%;
  object-fit: cover;
`

export const Scene = styled.div`
  //display: grid;
  width: ${({ $isMobile }) => $isMobile ? '100%' : '50%'};
  background: ${({theme}) => theme.background};
  //grid-template-columns: repeat(1, 1fr);
  //grid-template-rows: repeat(1, 1fr);
`
